import { useMutation, useQueryClient } from 'react-query';
import { retryDownloadQueueItemAsync } from '../../index';
import { DOWNLOAD_QUEUE_KEYS } from '../useQuery';

export const useRetryDownloadQueueItemAsync = () => {
  const queryClient = useQueryClient();

  return useMutation(retryDownloadQueueItemAsync, {
    onSuccess: () => {
      queryClient.invalidateQueries([DOWNLOAD_QUEUE_KEYS.ALL]);
    },
  });
};
